import React, { useMemo, useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useStocksUIContext } from '../StocksUIContext';
import { adjustTypeList } from '../StocksUIHelpers';
import axios, { baseUrl } from '../../../../../../redux/my-axios';

const PARAM_URL = '/params';
const prepareFilter = (queryParams, values) => {
  const { from, to, adjustType, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  filter.adjustType = adjustType !== '' ? adjustType : undefined;

  filter.from = from; // : new Date().toISOString().slice(0, 10);
  filter.to = to; // !== "" ? +to : new Date().toISOString().slice(0, 10);//to !== "" ? +to : Date.now();

  if (searchText) {
    filter.searchText = searchText;
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

const StocksFilter = (props) => {
  const [loaded, setLoaded] = useState(false);
  const StocksUIContext = useStocksUIContext();
  const StocksUIProps = useMemo(() => {
    return {
      queryParams: StocksUIContext.queryParams,
      setQueryParams: StocksUIContext.setQueryParams,
    };
  }, [StocksUIContext]);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    //console.log("applyFilter", values);
    const newQueryParams = prepareFilter(StocksUIProps.queryParams, values);
    //console.log("applyFilter prepareFilter..", newQueryParams);
    if (!isEqual(newQueryParams, StocksUIProps.queryParams)) {
      //console.log("!isEqual before");
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      //console.log(newQueryParams);
      StocksUIProps.setQueryParams(newQueryParams);
      //console.log("!isEqual after...", StocksUIProps.queryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          from: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 90)
            .toISOString()
            .slice(0, 10),
          to: new Date(new Date().getTime() + 1000 * 60 * 60 * 24)
            .toISOString()
            .slice(0, 10),
          adjustType: '',
          searchText: '',
        }}
        onSubmit={(values) => {
          //console.log("                                         ");
          //console.log("=============== SUBMIT =================");
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className='form form-label-right'>
            <div className='form-group row'>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    //placeholder="yyyy-mm-dd"
                    type='date'
                    //format="yyyy-mm-dd"
                    className='form-control'
                    placeholder='-с'
                    onBlur={handleBlur}
                    value={values.from}
                    onChange={(e) => {
                      setFieldValue('from', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='ORDER.LABEL.FROM' />
                    </b>
                  </small>
                </div>
              </div>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    type='date'
                    className='form-control'
                    name='to'
                    onBlur={handleBlur}
                    value={values.to}
                    onChange={(e) => {
                      setFieldValue('to', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='ORDER.LABEL.TO' />
                    </b>
                  </small>
                </div>
              </div>
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='adjustType'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('adjustType', e.target.value);
                    handleSubmit();
                  }}
                  value={values.adjustType}
                >
                  {adjustTypeList.map((option) => (
                    <option
                      key={`stockTypeList${option.code}`}
                      value={option.code}
                    >
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className='col-lg-2'>
                <input
                  type='text'
                  className='form-control'
                  name='searchText'
                  placeholder='текст'
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue('searchText', e.target.value);
                    handleSubmit();
                  }}
                />
              </div>

              <div className='col-lg-2'>
                <button
                  id='kt_stock_search_submit'
                  type='submit'
                  /* disabled={formik.isSubmitting} */
                  className={`btn btn-primary font-weight-bold`}
                  /* onClick={() => {
                                    //setFieldValue("loading", true);
                                    handleSubmit();
                                }} */
                >
                  <FormattedMessage id='STOCK.LABEL.SEARCH' />
                  {/*   <span><FormattedMessage id="AUTH.LOGIN.BUTTON" /></span> */}
                  {/* {values.loading && <span className="ml-3 spinner spinner-white"></span>} */}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(StocksFilter);
